import { render, staticRenderFns } from "./TestDemoModal.vue?vue&type=template&id=0760709a"
import script from "./TestDemoModal.vue?vue&type=script&lang=js"
export * from "./TestDemoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports